import { render } from "./PasswordResetConfirmation.vue?vue&type=template&id=509c4362"
import script from "./PasswordResetConfirmation.vue?vue&type=script&lang=ts"
export * from "./PasswordResetConfirmation.vue?vue&type=script&lang=ts"
script.render = render

export default script